import type { Organization } from '@interfaces/organization';
import { createContext, useContext } from 'react';

export type ClientContextType = {
  id: string;
  orgSettings: Organization;
  totalMarketValueCents: number;
};

export const ClientContext = createContext<ClientContextType | undefined>(
  undefined,
);

export const useClientContext = (): ClientContextType | undefined =>
  useContext(ClientContext);
